module.exports = __webpack_public_path__ + "static/media/icon-yt-lblue.12950c3d.svg";